import { render, staticRenderFns } from "./ProvisaoDadosIniciais.vue?vue&type=template&id=6d05a926&scoped=true"
import script from "./ProvisaoDadosIniciais.vue?vue&type=script&lang=ts"
export * from "./ProvisaoDadosIniciais.vue?vue&type=script&lang=ts"
import style0 from "./ProvisaoDadosIniciais.vue?vue&type=style&index=0&id=6d05a926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d05a926",
  null
  
)

export default component.exports